module.exports = __webpack_public_path__ + "static/abstract-art3-03041fb2f3c374b4904841c69e859ab5.webp";